import React from 'react';
import PriceGrid from '../../../ui/PriceGrid';
import { PRICES } from '../../../staticContent';
import { WpWidget } from '../../../widgets/WpChrome';
import { USE_WP_WIDGETS } from '../../../GlobalValues';

/**
 * §9 du plan (ligne 2.d) : les tarifs du listing viennent d'un `<wp-widget>` —
 * Placeloop ne maîtrise pas leur ISO. `PriceGrid` reste rendu en React tant que
 * le widget n'existe pas, pour montrer le rendu attendu et servir de spec CSS
 * à l'équipe WordPress (§9, note finale).
 */
const PricesWidget = () => {
  const staticVersion = <PriceGrid {...PRICES} />;
  return USE_WP_WIDGETS ? <WpWidget slug="tarifs" fallback={staticVersion} /> : staticVersion;
};

export default PricesWidget;
